export default __webpack_public_path__ + "static/media/480_dummy2016-fotograf01-mobile-de.006e85dc.png";